import React, { useEffect, useState } from 'react';
import {
  Box,
} from '@mui/material';
import UserSession from '../../../models/session/user-session.entity';
import storageService from '../../../services/storage.service';
import { useLocation } from 'react-router-dom';

const LoggedHeader = () => {
  const location = useLocation();

  const [showAll, setShowAll] = useState(false);

  const getCompanyLogo = () => {
    if (!storageService.getObject('session')) return;

    const sessionObj: UserSession = new UserSession(storageService.getObject('session'));
    if (sessionObj && sessionObj.company && sessionObj.company.logo) return sessionObj.company.logo;

    return 'assets/images/logo.svg';
  }

  useEffect(() => {
    const { pathname } = location;
    if (pathname !== '/' && pathname !== '/login') {
      setShowAll(true);
      return;
    }

    setShowAll(false);
  }, [location]);

  return (
    <>
      {showAll &&
        (<Box sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '10px 0',
          position: 'absolute',
          width: '100%',
          zIndex: -1
        }}>
          <img
            style={{ maxHeight: '40px' }}
            src={getCompanyLogo()}
            alt="logo"
            data-testid='infovist-white-logo'
          />
        </Box>)}
    </>
  );
}

export default LoggedHeader;
